import {reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums";


export const getTableColumns = ({ActionDropdown, deleteHandler, customUrl}) => {
    let tableColumns = [
        {
            header: "Customer",
            field: "fName",
            render: (item) => {
                return <>{item.fName}{item.lName ? ` ${item.lName}` : ''}</>;
            },
        },
        {header: "Products", field: "isAllProducts"},
        {header: "Maximum discount", field: "maximumDiscount"},
        {header: "Status", field: "status"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} edit={true} onDelete={deleteHandler} customUrl={customUrl}/>,
    });

    return tableColumns;
};


export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        customerId: item.customer?._id,
        fName: item.customer?.fName,
        lName: item.customer?.lName,
        maximumDiscount: item.maximumDiscount,
        products: item.products,
        isAllProducts: item.isAllProducts ? "Yes" : item.products.length,
        status: reverseEnum(Status)[item.status],
    }));
};
